import {Injectable} from '@angular/core';
import {Passenger} from '../models/passenger.model';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class SearchService {

    passengerLists: Passenger[] = [];
    passengerListsChanged = new Subject<Passenger[]>();

    passengerCharts: any[] = [];
    passengerChartsChanged = new Subject<any[]>();

    query: any;

    setPassengerList(passengers: Passenger[]) {
        this.passengerLists = passengers;
        this.passengerListsChanged.next(this.passengerLists.slice());
    }

    setPassengerChart(data: any) {
        this.passengerCharts = data;
        this.passengerChartsChanged.next(this.passengerCharts.slice());
    }

    setQuery(query: any) {

        this.query = query;
        if (query['group_by'].includes('drop_stop_id')) {
            this.query['group_by_criteria'] = 'drop_stop_id';
        }
        if (query['group_by'].includes('pick_stop_id')) {
            this.query['group_by_criteria'] = 'pick_stop_id';
        }
        if (query['group_by'].includes('route_id')) {
            this.query['group_by_criteria'] = 'route_id';
        }
        if (query['group_by'].includes('route_group_id')) {
            this.query['group_by_criteria'] = 'route_group_id';
        }
        if (query['group_by'].includes('day')) {
            this.query['group_by_date'] = 'day';
        }
        if (query['group_by'].includes('month')) {
            this.query['group_by_date'] = 'month';
        }
        if (query['group_by'].includes('year')) {
            this.query['group_by_date'] = 'year';
        }

    }

    getQuery() {
        return this.query;
    }


}
